var map = {
	"./24hours": 2,
	"./24hours.svg": 2,
	"./airport-grayscale": 3,
	"./airport-grayscale.jpg": 3,
	"./alarm-card": 4,
	"./alarm-card.svg": 4,
	"./blur-bg": 5,
	"./blur-bg.jpg": 5,
	"./bypass-switch": 6,
	"./bypass-switch.svg": 6,
	"./call": 7,
	"./call.svg": 7,
	"./chas": 8,
	"./chas.png": 8,
	"./cooling-solution": 9,
	"./cooling-solution.svg": 9,
	"./eca": 10,
	"./eca.png": 10,
	"./emergency-lighting": 11,
	"./emergency-lighting.svg": 11,
	"./facebook-image": 12,
	"./facebook-image.png": 12,
	"./favicon": 13,
	"./favicon.png": 13,
	"./generator": 14,
	"./generator-single": 15,
	"./generator-single.png": 15,
	"./generator.svg": 14,
	"./iso-14001": 16,
	"./iso-14001.jpg": 16,
	"./iso-45001": 17,
	"./iso-45001.jpg": 17,
	"./iso-9001": 18,
	"./iso-9001.jpg": 18,
	"./logo": 19,
	"./logo-mobile": 20,
	"./logo-mobile.svg": 20,
	"./logo-stack": 21,
	"./logo-stack.svg": 21,
	"./logo.svg": 19,
	"./mail": 22,
	"./mail.svg": 22,
	"./nic": 23,
	"./nic.png": 23,
	"./nqa": 24,
	"./nqa.png": 24,
	"./pdu": 25,
	"./pdu.svg": 25,
	"./safe-contractor": 26,
	"./safe-contractor.png": 26,
	"./tower": 27,
	"./tower.png": 27,
	"./transfer-switch": 28,
	"./transfer-switch.svg": 28,
	"./ups": 1,
	"./ups-grayscale": 29,
	"./ups-grayscale.jpg": 29,
	"./ups-single": 30,
	"./ups-single.png": 30,
	"./ups.png": 1,
	"./ups.svg": 42
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41;